/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HealthcareParty } from './HealthcareParty'
import { Replication } from './Replication'
import { User } from './User'

/**
 * initialisationData is an object that contains the initial replications (target must be an internalTarget of value base, healthdata or patient) and the users and healthcare parties to be created
 */
export class DatabaseInitialisation {
  constructor(json: JSON | any) {
    Object.assign(this as DatabaseInitialisation, json)
  }

  users?: Array<User>
  healthcareParties?: Array<HealthcareParty>
  replication?: Replication
}
